module.exports = __webpack_public_path__ + "static/media/html-5.41b5a97b.svg";